import { z } from 'zod';
import { DateOnlySchema, IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema, VersionSchema, } from './common.js';
export const NoteTargetTypeSchema = z.enum([
    'company',
    'contact',
    'lead',
    'opportunity',
    'project',
    'task',
    'job_file',
    'property',
    'inspection',
    'milestone',
    'customer_account',
]);
/** Narrative content on a record (specification 8.10). A note may spawn a task; it is never one. */
export const NoteSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    targetType: NoteTargetTypeSchema,
    targetId: IdSchema,
    authorMembershipId: IdSchema,
    body: z.string(),
    pinned: z.boolean(),
    version: VersionSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateNoteRequestSchema = z.strictObject({
    targetType: NoteTargetTypeSchema,
    targetId: IdSchema,
    body: z.string().trim().min(1).max(20_000),
    pinned: z.boolean().default(false),
});
export const UpdateNoteRequestSchema = z.strictObject({
    body: z.string().trim().min(1).max(20_000).optional(),
    pinned: z.boolean().optional(),
    version: VersionSchema,
});
export const NoteListQuerySchema = ListQuerySchema.extend({
    targetType: NoteTargetTypeSchema,
    targetId: IdSchema,
});
export const NoteListSchema = z.strictObject({ items: z.array(NoteSchema), page: PageInfoSchema });
/** Creates a task carrying the note's record context. */
export const NoteFollowUpRequestSchema = z.strictObject({
    title: z.string().trim().min(1).max(300),
    dueDate: DateOnlySchema.nullable().default(null),
    owner: IdSchema.nullable().default(null),
});
